<template>
    <article class="teaser teaser-story">
        <div class="teaser-story__graphic-pin" :style="{left: Math.floor(Math.random() * 30) + 40 + '%'}" >
            <img :src="pinImageMobile()" class="u-hide-from-medium">
            <img :src="pinImage()" class="u-show-from-medium">
        </div>
        <div class="teaser-story__inner">
            <div class="teaser-story__cover" :class="{ 'teaser-story__cover-no-image': !imageSizes.length}">
                <picture v-if="imageSrcSet" class="teaser-story__image image--border-radius">
                    <source :srcset="imageSrcSet">
                    <img :src="imageSizes[0]" alt="">
                </picture>
            </div>
            <div class="teaser-story__body">
                <h3 class="teaser-story__title">
                    <a v-if="link" class="teaser__title-link" :href="link">{{ title }}</a>
                    <span v-else>{{ title }}</span>
                </h3>
                <div class="teaser-story__name" >{{ personName }}</div>
                <div class="teaser-story__function">{{ personFunction }}</div>
            </div>
        </div>
    </article>
</template>
<script>

export default {
    name: 'StoryTeaser',
    props: [
        'title', 
        'link', 
        'imageSizes',
        'personName', 
        'personFunction'
    ],
    data() {
        return {
            imageSrcSet: null,
        }
    },
    mounted: function() {
        if(this.imageSizes) {
            this.imageSrcSet = this.imageSizes.map((src, index) => {
                if(index == 0) {
                    return `${src} 1x`;
                } else if(index === 1) {
                    return `, ${src} 2x`;
                }
            }).join(' ');
        }
    },
    methods: {
        pinImage() {
            return `${window.THEME_LINK}/dist/images/svg/story-pin.svg`;;
        },
        pinImageMobile() {
            return `${window.THEME_LINK}/dist/images/svg/story-pin-mobile.svg`;

        }
    }
};
</script>